export const CREDENTIALS = {
  username: 'admin',
  password: 'Inokom@123',
};

export const PHASES = [
  {
    phaseId: 'P0001',
    name: 'HYUNDAI ASSEMBLY',
    displayName: 'HYUNDAI ASSEMBLY',
    phase: '1',
    position: { top: '40.1%', left: '61.9%' },
  },
  {
    phaseId: 'P0004',
    name: 'MBA BODY SHOP',
    displayName: 'MBA BODY SHOP',
    phase: '2',
    position: { top: '28.3%', left: '38.6%' },
  },
  {
    phaseId: 'P0005',
    name: 'SDAE ENGINE PLANT P2',
    displayName: 'SDAE ENGINE PLANT P2',
    phase: '2',
    position: { top: '8.7%', left: '54.4%'},
  },
  {
    phaseId: 'P0006',
    name: 'NEW CENTRALIZED WAREHOUSE',
    displayName: 'NEW CENTRALIZED WAREHOUSE',
    phase: '2',
    position: { top: '5.8%', left: '70.1%' },
  },
  {
    phaseId: 'P0002',
    name: 'SDAE ENGINE PLANT P1',
    displayName: 'SDAE ENGINE PLANT P1',
    phase: '1',
    pinDirection: 'left',
    position: { top: '8.6%', left: '44.0%'},
  },
  {
    phaseId: 'P0007',
    name: 'MBA TRIM SHOP P2',
    displayName: 'MBA TRIM SHOP',
    phase: '2',
    position: { top: '50.2%', left: '66.4%' },
  },
  {
    phaseId: 'P0003',
    name: 'PPP ZONE B1',
    displayName: 'PPP ZONE B1',
    phase: '1',
    pinDirection: 'down',
    position: { top: '17.0%', left: '14.4%'},
  },
  {
    phaseId: 'P0008',
    name: 'PPP ZONE C',
    displayName: 'PPP ZONE C',
    phase: '2',
    position: { top: '14.1%', left: '11.5%'},
  },
  {
    phaseId: 'P0009',
    name: 'PPP ZONE B2',
    displayName: 'PPP ZONE B2',
    phase: '2',
    position: { top: '16.8%', left: '20.3%'},
  },
  {
    phaseId: 'P0010',
    name: 'IVP1',
    displayName: 'IVP1',
    phase: '2',
    position: { top: '18.8%', left: '2.8%'},
  },
  {
    phaseId: 'P0011',
    name: 'TCF WAREHOUSE',
    displayName: 'TCF WAREHOUSE',
    phase: '2',
    position: { top: '69.6%', left: '80.4%' },
  },
];
